import {DeliveryAddress} from "@app/core/delivery-point/application/dtos/delivery-address";

export class DeliveryAddressMapper {
    static serialize(param: DeliveryAddress): any {
        return {
            address: param.address,
            country: param.country,
            province: param.province,
            postal_code: param.postalCode,
            city: param.city
        }
    }
}